// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".start-effecr-evaluation[data-v-7201da62]{min-height:200px;padding:1rem 0 6rem 0}.text-green[data-v-7201da62]{color:#2cb774}.text-spacing[data-v-7201da62]{margin-bottom:4%;font-size:1.2rem;font-weight:700;color:#333}.begin-button[data-v-7201da62]{padding-top:2rem}", ""]);
// Exports
module.exports = exports;
